import { TADManager } from "tad-core";
import { Shark } from "shark-mvc";
import "Models/VehicleActivity";

var vehicleActivityManager = Shark.createJaw("vehicleActivityManager");

vehicleActivityManager.addMethod("getList", function () {
	TADManager.clearCollection();
	TADManager.createTAD({ t: "vehicleActivity", a: "getList" });

	TADManager.sendDefaultCollection(function (response) {
		var responseTAD = response.getItem(0);

		console.log({ where: "vehicleActivityManager > getList > apiResponse", response: response, responseTAD: responseTAD });

		switch (responseTAD.checkResponseStatus()) {
			case "ok":
				Shark.set({
					vehicleList: Shark.getInstanceList("Vehicle", responseTAD.responseData[0].data),
					vehicleTotalLength: responseTAD.responseData[0].total
				});

				vehicleActivityManager.emit("listChanged");

				break;
			case "ko":
				vehicleActivityManager.emit("getListError", responseTAD.lastErrorMessage);
				break;
		}
	});
});

vehicleActivityManager.addMethod("save", function (vehicleActivity) {
	const action = "create";

	TADManager.clearCollection();
	TADManager.createTAD({ t: "vehicleActivity", a: action, d: [vehicleActivity.export()]});

	TADManager.sendDefaultCollection(function (response) {
		var responseTAD = response.getItem(0);
		console.log({ where: "vehicleActivityManager > save > apiResponse", response: response, responseTAD: responseTAD });

		switch (responseTAD.checkResponseStatus()) {
			case "ok":
                vehicleActivity.import(responseTAD.responseData[0].data);
                vehicleActivity.clean();
                
				vehicleActivityManager.emit("saved");
				break;
			case "ko":
				vehicleActivityManager.emit("saveError", responseTAD.lastErrorMessage);
				break;
		}
	});
});

Shark.registerController(vehicleActivityManager);

export { vehicleActivityManager };